import { isDevelopmentEnv } from "../../helpers/envConfigHelper";

export const TARGET_ANCHOR_KEY = 'is';

export const RELEASES: {
    version: string;
    date: string;
    /** If marked as true it will appear only in localhost env. */
    draft?: boolean;
}[] = [
        {
            version: '1.0.0',
            date: 'N/A',
            draft: true
        }
    ];


export const VISIBLE_RELEASES = RELEASES.filter(release => {
    const isDevelopment = isDevelopmentEnv();
    if (isDevelopment) return release;
    return !release.draft;
});

export const CURRENT_RELEASES_VERSION = RELEASES.find(release => {
    const isDevelopment = isDevelopmentEnv();
    if (isDevelopment) return release;
    return !release.draft;
});

export const headlineValue = (version: string, draft?: boolean) => checkReleaseVersion(`Version: ${version}`, draft);
export const checkReleaseVersion = (label: string, draft?: boolean) => (draft ? '(Draft) - ' : '') + label;
